import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import Close from '@material-ui/icons/Close';
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import clsx from 'clsx';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import TRANSACTIONS from "../../actionTypes/transactions_actionType.js"

const moment = extendMoment(originalMoment);

class HeaderLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDatePicker: false,
      status:[{
        id:'email_sent',
        name:'Email Sent'
      },{
        id:'email_not_sent',
        name:'Email Not Sent'
      }]
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.props.resetInitialData()
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        openDatePicker: false
      })
    }
  }

  // filterByDate = (name, value) => {
  //   this.props.filterRestaurant({
  //     value: value,
  //     name: name
  //   })
  // }

  onSelectDate = (value) => {
    const { query } = this.props
    this.setState({
      openDatePicker:false
    },()=>{
      let newQuery = query
      newQuery['selectedDateRange'] = value
      this.props.updateQueryForTransaction(newQuery)
      // fetchPartnersList(newQuery)
    })
  }

  render() {
    const {
      classes,
      query,
      selectedDateRange,
      updateQueryForTransaction
    } = this.props;
    const {
      openDatePicker,
      status
    } = this.state;
    return (
      <div className="header_main_links manage-offers-header manage-partner-header">
        <FormControl className={clsx(classes.formControl, 'filter-by-offer-code')}>
            <InputLabel htmlFor="age-simple">Filter by Status</InputLabel>
            <Select
              value={query.status}
              onChange={(event)=>{
                let newQuery = query
                newQuery['status'] = event.target.value
                updateQueryForTransaction(newQuery)
              }}
              inputProps={{
                name: 'percentage',
                id: 'age-simple',
              }}
            >
              <MenuItem value={'all'}>All</MenuItem>
              {status.map((s,index) => {
                return <MenuItem key={index} value={s.id}>
                  {s.name}
                </MenuItem>
              })}
            </Select>
        </FormControl>
        <div className='validity-date-picker'>
          <FormControl fullWidth>
            <InputLabel htmlFor="adornment-password">Filter By Date</InputLabel>
            <Input
              readOnly={true}
              id="adornment-password"
              fullWidth
              onClick={() => {
                this.setState({
                  openDatePicker: true
                })
              }}
              value={selectedDateRange ? `${moment(new Date(selectedDateRange.start._d)).format('DD/MM/YYYY')} - ${moment(new Date(selectedDateRange.end._d)).format('DD/MM/YYYY')}` : ''}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton aria-label="Toggle password visibility" onClick={(e) => {
                    e.stopPropagation()
                    this.onSelectDate('')
                  }}>
                    <Close />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          {
            openDatePicker &&
            <div className='date-range-picker-container' ref={(node) => {
              this.wrapperRef = node
            }}>
              <DateRangePicker
                value={selectedDateRange &&
                          selectedDateRange.start &&
                          selectedDateRange.end ? moment.range(selectedDateRange.start._d, selectedDateRange.end._d) : null}
                onSelect={(value) => {
                  this.onSelectDate(value)
                  this.setState({
                    openDatePicker: false
                  }, () => {
                    // this.filterByDate('date', value)
                  });
                }}
                singleDateRange={true}
              />
            </div>}
        </div>

      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    query: state.transactions.query,
    selectedDateRange: state.transactions.query.selectedDateRange,
    selectedStatus: state.transactions.query.status
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateQueryForTransaction: (query) => dispatch({
      type: TRANSACTIONS.UPDATE_QUERIES_FOR_TRANSACTION,
      payload: query
    }),
    resetInitialData: () => {
      dispatch({ type: TRANSACTIONS.RESET_INITIAL_DATA })
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(headerLinksStyle)(HeaderLinks));
